import { parseJSON } from '../libs/helpers'
import { session } from './session'

export function updateScrollCache(collection, product) {
  const prev = session.scrollCache.get() ?? {}
  const cache = new Map(Object.entries(parseJSON(prev)))

  if (product) cache.set(collection, product)
  else cache.delete(collection)

  const next = Object.fromEntries(cache.entries())
  session.scrollCache.set(next)
}
